<script setup lang="ts">
import type { ISkuSelectorOption } from '../models';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{ option: ISkuSelectorOption; isActive?: boolean; isUnavailable?: boolean }>();
</script>

<template>
  <MMText
    font="Body M/Medium"
    class="sku-option-text"
    :class="{
      'sku-option-text_active': isActive,
      'sku-option-text_unavailable': isUnavailable,
    }"
  >
    {{ option.title }}
  </MMText>
</template>

<style scoped lang="stylus">
.sku-option-text
  box-sizing border-box
  padding 8px 12px
  border-radius 10px
  min-height 42px
  cursor pointer
  border solid 1px var(--border-regular)
  display flex
  align-items center
  max-width 370px
  min-width 48px
  background-color #ffffff
  position relative
  overflow hidden
  justify-content center
  &:hover
    background-color #F4F5F5

  &_active
    outline solid 2px var(--border-focused)
    outline-offset -2px

  &_unavailable
    border-color var(--border-disabled)
    color var(--text-disabled)
    background-color var(--button-disabled-onprimary)
    &::after
      content ''
      background-color var(--border-disabled)
      position absolute
      transform rotateZ(-135deg)
      left 0
      right 0
      height 1px
</style>
